export default __webpack_public_path__ + "static/media/arrow-right.5273d6c9.svg";